import getWithToken from './base/get-with-token'

const getDeviceAlertPointMap = (type, searchData) => getWithToken(`/dashboard/device-alert-point-map?type=${type}`)({
    ...searchData,
})

export default getDeviceAlertPointMap